import { render, staticRenderFns } from "./OptoutSettingModal.vue?vue&type=template&id=657d045c&scoped=true"
import script from "./OptoutSettingModal.vue?vue&type=script&lang=js"
export * from "./OptoutSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657d045c",
  null
  
)

export default component.exports